$(function () {
	angular.bootstrap(document, ['a3.cabin.reports']);
});
		
var a3_cabin_reports = angular.module('a3.cabin.reports', [ 
    //angular modules
    'ngSanitize', 
    'ngRoute', 
    'ngTouch',
    
    //3rd party modules
    'angular-md5',
	'LocalStorageModule', 
    'ui.bootstrap',
    'nya.bootstrap.select',
    'ui.toggle',
    'ui.sortable',

    //Our modules
    'MyDirectives',
    'LocalStorageMD5Module'

]);

 




